// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__33Pke","messages":"Chat_messages__3wy3c","dateDivider":"Chat_dateDivider__BAMje"};